<template>
  <div>
    <section id="path" class="design-section">
      <h4
        style="
          font-size: 30px;
          font-family: 'Poppins', sans-serif;
          padding: 0px;
        "
      >
        Learning
        <span style="color: #42b983">Path</span>
      </h4>
      <div class="timeline p-5">
        <div class="timeline-empty"></div>

        <div class="timeline-middle">
          <div class="timeline-circle"></div>
        </div>

        <div class="timeline-component timeline-content">
          <h3>Cyber Security IAM Engineer</h3>
          <p class="text-overline">
            Working at LATAM's largest e-commerce and fintech platform.
          </p>
          <p>
            <a href="https://www.mercadolibre.com.ar" target="_blank"
              >Mercado Libre</a
            >
          </p>
          <p class="date">2025 - Present Day</p>
        </div>

        <div class="timeline-component timeline-content">
          <h3>IAM Senior Analyst</h3>
          <p class="text-overline">
            AWS Lambda automation, SSO integration, and IAM consulting.
          </p>
          <p>
            <a href="https://www.kavak.com/ar" target="_blank">Kavak</a>
          </p>
          <p class="date">2024 - 2025</p>
        </div>

        <div class="timeline-middle">
          <div class="timeline-circle"></div>
        </div>

        <div class="timeline-empty"></div>

        <div class="timeline-empty"></div>

        <div class="timeline-middle">
          <div class="timeline-circle"></div>
        </div>

        <div class="timeline-component timeline-content">
          <h3>Linux Career</h3>
          <p class="text-overline">Education degree specialist in Linux.</p>
          <p>
            <a href="https://www.educacionit.com/carrera-linux" target="_blank"
              >Educacion IT</a
            >
          </p>
          <p class="date">2022 - 2023</p>
        </div>

        <div class="timeline-component timeline-content">
          <h3>SSR Full Stack Developer</h3>
          <p class="text-overline">
            IAM consulting, Keycloak/Gluu specialist, and server maintenance.
          </p>
          <p>
            <a href="https://www.identicum.com" target="_blank">Identicum</a>
          </p>
          <p class="date">2022 - 2024</p>
        </div>

        <div class="timeline-middle">
          <div class="timeline-circle"></div>
        </div>

        <div class="timeline-empty"></div>

        <div class="timeline-empty"></div>

        <div class="timeline-middle">
          <div class="timeline-circle"></div>
        </div>

        <div class="timeline-component timeline-content">
          <h3>Systems Analyst</h3>
          <p class="text-overline">
            Education degree specialist in software development.
          </p>
          <p>
            <a
              href="https://landing.ort.edu.ar/sistemas?utm_source=Google&utm_medium=busqueda&utm_campaign=sistema&gclid=EAIaIQobChMImL2z67WS_wIVLEJIAB3KGQQiEAAYASAAEgI5APD_BwE"
              target="_blank"
              >ORT Argentina</a
            >
          </p>
          <p class="date">2021 - 2023</p>
        </div>
      </div>
    </section>
    <div
      class="elementor-shape elementor-shape-bottom"
      data-negative="false"
      id="contactme"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 10 1000 100"
        preserveAspectRatio="none"
        style="
          background: rgb(77 155 118);
          fill: white;
          transform: rotate(180deg);
        "
      >
        <path
          class="elementor-shape-fill"
          d="M0,0c0,0,0,6,0,6.7c0,18,240.2,93.6,615.2,92.6C989.8,98.5,1000,25,1000,6.7c0-0.7,0-6.7,0-6.7H0z"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
function reveal() {
  var reveals = document.querySelectorAll(".timeline-component");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 2500;

    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
}

window.addEventListener("scroll", reveal);
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400&display=swap");

#path {
  background: linear-gradient(
    to top,
    rgb(52 144 103 / 90%),
    rgb(242, 242, 242),
    rgb(219, 219, 219),
    rgb(234, 234, 234)
  );
  padding: 100px 0px 50px;
  border-bottom: 1px solid rgb(52 144 103 / 90%);
}

a {
  text-decoration: none;
  margin: 0px;
  color: white;
}

a:hover {
  color: white;
}

.reveal {
  position: relative;
  transform: translateY(150px);
  opacity: 0;
  transition: 1s all ease;
}

.reveal.active {
  transform: translateY(0);
  opacity: 1;
}

@import url("https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400&display=swap");
.design-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #1f1f1f;
  min-height: 100vh;
  padding: 100px 0;
  font-family: Poppins, sans-serif;
}

.timeline-component:hover {
  scale: 30px;
}

.design {
  display: flex;
  align-items: center;
  justify-content: center;
}

.date {
  font-size: 12px;
  margin: 0px;
}

.timeline {
  width: 80%;
  height: auto;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.timeline-content {
  padding: 20px;
  background: rgb(92 163 129);
  -webkit-box-shadow: 5px 5px 10px #535252, -5px -5px 10px #494747;
  box-shadow: 5px 5px 10px #6a6969, -5px -5px 10px #676666;
  border-radius: 5px;
  color: white;
  padding: 1.75rem;
  transition: 0.4s ease;
  overflow-wrap: break-word !important;
  margin: 1rem;
  margin-bottom: 20px;
  border-radius: 6px;
}

.timeline-component {
  margin: 0px 20px 20px 20px;
}

.timeline-content:hover {
  padding: 30px;
}

@media screen and (min-width: 768px) {
  .timeline {
    display: grid;
    grid-template-columns: 1fr 3px 1fr;
  }
  .timeline-middle {
    position: relative;
    background-image: linear-gradient(45deg, #414140, #828080, #403f40);
    width: 3px;
    height: 100%;
  }
  .main-middle {
    opacity: 0;
  }
  .timeline-circle {
    position: absolute;
    top: 0;
    left: 50%;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-image: linear-gradient(45deg, #0c0501, #211315, #1d1a1d);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
}
</style>
